import { CommonModule } from '@angular/common';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { BlocoCarteirasComponent } from './bloco-carteiras/bloco-carteiras.component';
import { BlocoBuscasSalvasComponent } from './bloco-buscas-salvas/bloco-buscas-salvas.component';
import { BlocoNovasOportunidadesComponent } from './bloco-novas-oportunidades/bloco-novas-oportunidades.component';
import { BlocoSolicitarNovaObraComponent } from './bloco-solicitar-nova-obra/bloco-solicitar-nova-obra.component';
import { BlocoTarefasComponent } from './bloco-tarefas/bloco-tarefas.component';
import { BlocoStatusRedeComponent } from './bloco-status-rede/bloco-status-rede.component';
import { BlocoRelatoriosComponent } from './bloco-relatorios/bloco-relatorios.component';
import { AuthService } from '../shared/services/auth/auth.service';
import { Router } from '@angular/router';
import { ObraNavegacaoService } from '../shared/services/obras-navegacao/obras-navegacao.service';
import { BlocoPontosAtencaoComponent } from './bloco-pontos-atencao/bloco-pontos-atencao.component';
import { PopUpAvisoComponent } from '../shared/components/pop-up-aviso/pop-up-aviso.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    BlocoCarteirasComponent,
    BlocoBuscasSalvasComponent,
    BlocoNovasOportunidadesComponent,
    BlocoSolicitarNovaObraComponent,
    BlocoTarefasComponent,
    BlocoStatusRedeComponent,
    BlocoRelatoriosComponent,
    BlocoPontosAtencaoComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  exibirFichaDaObra = false;
  idObraSelecionada: number | null = null;
  obraIds: number[] = [];
  indiceObraAtual = 0;

   private readonly modalService = inject(BsModalService);

  constructor( @Inject(AuthService) private authService: AuthService, private router: Router, private obraNavegacaoService: ObraNavegacaoService) {}

  ngOnInit(): void {
    this.showPopupAviso();
  }

  showPopupAviso(): void {
    if (this.authService.level === 'Restrito') return;

    const userId = this.authService.userID;
    const storageKey = PopUpAvisoComponent.getStorageKey(userId);
    const hasVisualized = localStorage.getItem(storageKey);

    if (!hasVisualized) {
      this.modalService.show(PopUpAvisoComponent, {
        initialState: {
          userId: userId || undefined,
        },
      });
    }
  }

  abrirFichaObra(event: {
    workID: number;
    obraIds: number[];
    modulo: string;
  }): void {
    if (!event?.workID || !event.modulo) {
      return;
    }

    this.obraNavegacaoService.setObraIds(event.obraIds, event.modulo);
    this.router.navigate(['/buscas', event.modulo, 'detalhes', event.workID]);
  }
  
}
